import { ProceduresFinancialItems } from './ProceduresFinancialItems';

export default ProceduresFinancialItems;
